/**
 * Le récapitulatif du dossier, sur la page de fin de chantier. Un bloc, plus une étape.
 *
 * ⚠️ IL A ÉTÉ UNE ÉTAPE, ET SA DISPARITION EST VOULUE.
 *
 * Le 27/08, sur demande de David, le lot C a sorti le mandat de l'écran de signature
 * unique et lui a donné son étape 4, avec sa propre signature. C'était le correctif
 * d'un défaut réel : le client signait la réception de ses travaux avant d'avoir donné
 * son mandat, et une seule signature apposée pour deux engagements juridiques distincts
 * ne prouvait ni l'un ni l'autre.
 *
 * Le 30/08, toujours David : le mandat et les consentements DESCENDENT sur la page de
 * fin de chantier, et une seule signature couvre l'ensemble. Cette demande remplace
 * celle du 27/08. Le fichier a donc changé de nom plutôt que d'être supprimé : ce qu'il
 * montre — le dossier tel qu'il partira — reste nécessaire, c'est son statut d'étape
 * qui ne l'est plus.
 *
 * ⚠️ SON HABILLAGE « MANDAT DE FLEXIBILITÉ » A ÉTÉ RETIRÉ LE 02/09, ET IL NE SE REMET
 * PAS. Le bloc portait un titre « Mandat de flexibilité » et la phrase « Le document
 * complet est envoyé au client par e-mail pour signature électronique à la fin du
 * chantier. ». Demande de Boubacar, mot pour mot : « à l'étape 4 du wizard, enlever la
 * mention mandat de flexibilité etc. qui entoure les infos du client et ne garder que
 * les infos du client remplies dans le wizard ».
 *
 * Deux raisons de ne pas les rétablir, et elles ne sont pas cosmétiques. Le client lit
 * cet écran PAR-DESSUS L'ÉPAULE DU POSEUR, au moment où il signe : nommer ici un
 * document qu'il ne voit pas, et annoncer un envoi par e-mail « à la fin du chantier »
 * alors qu'il signe à l'instant même, décrit un parcours qui n'existe plus depuis le
 * 30/08. Ce que la page engage est dit une seule fois, à l'endroit qui l'engage — le
 * libellé de la signature, en bas de `StepFinChantier`.
 *
 * ⚠️ CE QUE LE MANDAT CONTIENT NE SE DÉCIDE PAS ICI. Ce bloc rappelle le dossier ; le
 * texte du mandat, ses clauses et ses consentements appartiennent au lot B. Il ne porte
 * donc aucune clause, et il ne fait plus signer : la signature est unique, elle vit en
 * bas de la page.
 *
 * ⚠️ LES DEUX `data-testid` SONT DES POINTS D'ANCRAGE EXTERNES, ils ne se renomment pas
 * sans leurs appelants : `bloc-mandat` est compté à l'écran par
 * `deploy/recette-parcours-signature.mjs` et exigé par `test_parcours_ordre.py` ;
 * `mandat-recapitulatif` est exigé par `test_lot_r_signature_unique.py`. Le retrait du
 * titre a fusionné les deux encadrés d'origine en un seul — le bloc EST devenu le
 * récapitulatif — mais les deux noms restent, l'un sur la carte, l'autre sur son
 * contenu.
 *
 * Présentationnel : il ne sait ni enregistrer ni naviguer.
 */
export default function BlocMandat({ client, enabledEquipements, referenceChantier }) {
  return (
    // Une carte comme les autres blocs de la page (attestation, consentements, photos),
    // et plus une carte dans une carte : sans titre à porter, le double encadré ne
    // séparait plus rien.
    <div className="rounded-lg border border-neutral-200 bg-white p-4"
         data-testid="bloc-mandat">
      {/* Le dossier tel qu'il partira. Le client signe ce qu'il a sous les yeux. */}
      <div className="text-[12px] space-y-1" data-testid="mandat-recapitulatif">
        <p><span className="text-neutral-400">Client :</span> {client.civilite} {client.prenom} {client.nom}</p>
        <p><span className="text-neutral-400">Adresse :</span> {client.adresse}, {client.code_postal} {client.ville}</p>
        <p>
          <span className="text-neutral-400">Équipements :</span>{' '}
          {enabledEquipements.map(([t, v]) => `${t} ${v.marque || ''} ${v.modele || ''}`.trim()).join(' • ') || '-'}
        </p>
        <p><span className="text-neutral-400">Réf. chantier :</span> {referenceChantier || '-'}</p>
      </div>
    </div>
  );
}
